import React from 'react';
import { useFelaEnhanced } from '@ackee/fela';

import { DynamicContainer } from 'modules/ui';

import * as felaRules from './BlogContentContainer.rules';

export interface BlogContentContainerProps {
    children: React.ReactNode;
}

export const BlogContentContainer = ({ children }: BlogContentContainerProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules);

    return (
        <DynamicContainer isFluid extend={{ container: rules.extendWrapperContainer }}>
            <div className={styles.container}>{children}</div>
        </DynamicContainer>
    );
};
